<script>
/**
 * Mixin that allows setting validation rules components or specific values.
 * Under the hood we use Vee Validate v3 (https://vee-validate.logaretm.com/v3).
 * Also see (https://vee-validate.logaretm.com/v3/guide/rules.html#rules) for list of available rules
 */
import { validate } from 'vee-validate';
import _ from 'lodash';

async function $validate(value, validations) {
  if (_.isNil(validations)) {
    return {
      valid: true,
    };
  }

  if (_.isString(validations)) {
    return await validate(value, validations);
  }

  if (_.isObject(validations)) {
    if (validations.$rules) {
      return await validate(value, validations.$rules, validations.$options);
    }
    return await validate(value, validations);
  }

  if (_.isFunction(validations)) {
    return await validations(value);
  }

  throw new Error(`Validations can either by a function, an object or a string. Actual type: ${typeof validations}`);
}

export default {
  name: 'WithValidation',
  mounted() {
    this.$emit('observe', this);
  },
  destroyed() {
    this.$emit('unobserve', this);
  },
  props: {
    validations: [String, Object, Function],
    validatedValue: {
      type: [String, Object, Number, Boolean],
      default: undefined,
    },
  },
  data() {
    return {
      validationErrorMessage: null,
      failedRules: null,
    };
  },
  computed: {
    validationError() {
      return !!this.validationErrorMessage;
    },
    valueToValidate() {
      if (!_.isNil(this.validatedValue)) {
        return this.validatedValue;
      }
      return this.value;
    },
  },
  methods: {
    reset() {
      this.validationErrorMessage = null;
      this.failedRules = null;
    },
    async validate() {
      const result = await $validate(this.valueToValidate, this.validations);
      if (result.valid) {
        this.reset();
      } else {
        const [validationErrorMessage] = result.errors;
        this.validationErrorMessage = validationErrorMessage;
        this.failedRules = result.failedRules;

        this.$emit('validation-error', {
          validationErrorMessage: this.validationErrorMessage,
          failedRules: this.failedRules,
        });
      }
      return result;
    },
  },

};
</script>
